import { Arrangement } from 'types/arrangement';
import { getTotalCreditPoints as getSubjectsCP } from 'utils/subject';

/**
 * Calculates the total credits points for an Arrangment.
 * @export
 * @param {Arrangement} arrangement
 * @return {*}  {number}
 */
export function getTotalCreditPoints(arrangement: Arrangement): number {
  if (arrangement.guaranteedEntryOnly) {
    return 0;
  }
  return getSubjectsCP(arrangement.subjects);
}
